module.exports = __webpack_public_path__ + "static/20191017_173526_optimized-faa18a6c6d910bf6fd60ccd5cc36fe04.jpg";